export default __webpack_public_path__ + "static/media/icon-moon.7101c57d.svg";